export default {
  message: {
    "strid1": "登陆",
    "strid2": "公告",
    "strid3": "更多",
    "strid4": "处罚查询",
    "strid5": "举报查询",
    "strid6": "处罚公示",
    "strid7": "安全科普",
    "strid8": "处罚规则",
    "strid9": "举报时间",
    "strid10": "举报玩家",
    "strid11": "举报原因",
    "strid12": "举报结果",
    "strid13": "已受理",
    "strid14": "存在违规",
    "strid15": "处罚时间",
    "strid16": "处罚原因",
    "strid17": "解封时间",
    "strid18": "申诉",
    "strid19": "已申诉",
    "strid20": "核实中",
    "strid21": "申诉失败",
    "strid22": "申诉结果",
    "strid23": "申诉成功",
    "strid24": "提示",
    "strid25": "申诉表",
    "strid26": "可能被惩罚的原因",
    "strid27": "视频/图片/使用的外挂软件下载地址",
    "strid28": "描述",
    "strid29": "自助查询系统",
    "strid30": "游戏昵称",
    "strid31": "游戏id（区服）",
    "strid32": "游戏等级",
    "strid33": "游戏段位",
    "strid34": "游戏年龄(年)",
    "strid35": "设备型号",
    "strid36": "联系邮箱",
    "strid37": "关联账号id（google，fb或者vk）",
    "strid38": "在申诉前， 你需要填写您的账号信息以及联系方式以便我们能够联系到您",
    "strid39": "我的账号被盗了。",
    "strid40": "我没有作弊， 我的账号只有我自己使用。",
    "strid41": "我承认我作弊了， 下次不会再犯。",
    "strid42": "请输入 ",
    "strid43": "联系客服",
    "strid44": "我知道了",
    "strid45": '不',
    "strid46": '',

  }
}
